import { useCallback, useState } from 'react';

import RASnackbar from '@modules/_shared/components/RASnackbar';
import { useLocale } from '@shared/hooks/locale';

export function useWatermarkSkippedWarning() {
  const { t } = useLocale();
  const [skippedWarning, setSkippedWarning] = useState<string | null>(null);

  const notifySkipped = useCallback(
    (skippedCount: number) => {
      if (skippedCount > 0) {
        setSkippedWarning(
          t(
            '{{count}} image(s) could not be watermarked and were left unchanged',
            { count: skippedCount },
          ),
        );
      }
    },
    [t],
  );

  const snackbar =
    skippedWarning != null ? (
      <RASnackbar
        message={skippedWarning}
        severity="warning"
        onClose={() => setSkippedWarning(null)}
      />
    ) : null;

  return { notifySkipped, snackbar };
}
